import { FunctionComponent, ReactNode, useState } from 'react';
import { createStyles, makeStyles, Box, Typography } from '@material-ui/core';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PortalModal from '../../UI/Portals';
import { DropdownOption } from '../ui/Dropdown/model';
import { BottomModalMobile } from 'components/UI/Portals/variants';

const useStyles = makeStyles(() =>
    createStyles({
        modalContainer: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            padding: '0px 14px'
        },
        modalItem: {
            'display': 'flex',
            'flexDirection': 'row',
            'alignItems': 'center',
            'justifyContent': 'center',
            'width': '100%',
            'height': '54px',
            'margin': '2px 0px',
            'borderBottom': '1px solid #D4D4D4',
            'gap': 10,
            '&:last-child': {
                borderBottom: 'none'
            }
        },
        itemLabel: {
            fontSize: '14px',
            fontWeight: 500
        },
        toggleIcon: {
            cursor: 'pointer'
        },
        icon: { height: 17 },
        iconDisabled: { color: '#D3D3D3' },
        itemLabelDisabled: { color: '#D3D3D3' }
    })
);

interface OptionsModalProps {
    options: Array<DropdownOption>;
    actionComponent?: ReactNode;
    onClick: (optrionId: string) => void;
}

const OptionsModal: FunctionComponent<OptionsModalProps> = props => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleModalHandler = () => setIsOpen(!isOpen);

    const selectOptionHandler = (id: string) => {
        props.onClick(id);
        setIsOpen(false);
    };

    // Show disabled options but render them inert — we will skip invoking click when disabled
    const filteredOptions = props.options;

    return (
        <>
            {
                <span
                    className={classes.toggleIcon}
                    aria-label="Staff actions"
                    onClick={toggleModalHandler}
                >
                    {props.actionComponent ? props.actionComponent : <FontAwesomeIcon icon={faEllipsis} />}
                </span>
            }
            <PortalModal
                isActive={isOpen}
                mode="mobileModal"
                onClose={() => setIsOpen(false)}
            >
                <BottomModalMobile>
                    <Box className={classes.modalContainer}>
                        {filteredOptions.map((modalItem, index) => {
                            const isDisabled = modalItem.disabled === true;
                            return (
                                <Box
                                    key={index}
                                    className={classes.modalItem}
                                    onClick={() => {
                                        if (isDisabled) return;
                                        if (modalItem.onClick) {
                                            modalItem.onClick();
                                        } else {
                                            selectOptionHandler(modalItem.id);
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={modalItem.icon}
                                        className={
                                            isDisabled ? `${classes.icon} ${classes.iconDisabled}` : classes.icon
                                        }
                                    />
                                    <Typography
                                        className={
                                            isDisabled
                                                ? `${classes.itemLabel} ${classes.itemLabelDisabled}`
                                                : classes.itemLabel
                                        }
                                    >
                                        {modalItem.title}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                </BottomModalMobile>
            </PortalModal>
        </>
    );
};

export default OptionsModal;
